import React, { useEffect, useState,useRef } from "react";
import "./mine.scss";
import Title from "../../components/Title";
import { Input, message, Modal, Form } from "antd";
import { useRequest } from "ahooks";
import useAuthStore from "../../store/auth";
import { updateNickname,updatePhone } from "../../api/user";
import { getCode } from "../../api/auth";

export default function Mine() {
  const [showOptions, setShowOptions] = useState(false);
  const [setShowCreate] = useState(false);
  const { userInfo,setUserInfo } = useAuthStore();
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [title, setTitle] = useState(null);
  const [editName, setEditName] = useState(false);
  const [editNickname, setEditNickname] = useState(
    userInfo?.user.nickname || ""
  );
   const [countdown, setCountdown] = useState(0);
   const timerRef = useRef(null);
  const formRef = useRef(null);

  const { runAsync: updateUserInfo } = useRequest(updateNickname, {
    manual: true,
    onSuccess: (res) => {
      if (res.code === 200) {
        message.success("修改成功");
        setEditName(false);
      } else {
        message.error(res.msg);
      }
    },
    onError: (err) => {
      message.error(err.message);
    }
  });

  const { runAsync: getCodeRequest } = useRequest(getCode, {
    manual: true,
    onSuccess: (res) => {
      if (res.code === 200) {
        message.success("验证码已发送");
        setCountdown(60);
      } else {
        message.error(res.msg);
      }
    },
    onError: (err) => {
      message.error(err.message);
    }
  });

  const { runAsync: updatePhoneRequest } = useRequest(updatePhone, {
    manual: true,
    onSuccess: (res) => {
      if (res.code === 200) {
        message.success("手机号修改成功");
        setIsModalOpen(false);
      } else {
        message.error(res.msg);
      }
    },
    onError: (err) => {
      message.error(err.message);
    }
  });

  const handleUpdateNickname = async () => {
      updateUserInfo({ nickname: editNickname });
  }

  useEffect(() => {
    if (countdown > 0) {
      timerRef.current = setTimeout(() => {
        setCountdown(countdown - 1);
      }, 1000);
    } else {
      if (timerRef.current) {
        clearTimeout(timerRef.current);
        timerRef.current = null;
      }
    }
    return () => {
      if (timerRef.current) {
        clearTimeout(timerRef.current);
        timerRef.current = null;
      }
    };
  }, [countdown]);
  const handlePhone = (text) => {
    setTitle(
      <div className="modalTitle">
        <p>{text}</p>
      </div>
    );
    setIsModalOpen(true);
  };

  // const handleEmail = () => {
  // setIsModalOpen(true);
  // }

  const handleOk = () => {
    formRef.current
      .validateFields()
      .then((values) => {
        console.log("Received values:", values);
        if (title.props.children.props.children === "绑定手机号") {
          // 绑定手机号
          console.log("绑定手机号");
        } else if (title.props.children.props.children === "修改手机号") {
          // 修改手机号
          console.log("修改手机号");
          updatePhoneRequest({
            field: "phone",
            value: values.phone,
            code: values.code,
          });
        }
      })
      .catch((errorInfo) => {
        console.log("Failed:", errorInfo);
        message.error("请检查输入");
      });
  };

  const handleCancel = () => {
    setIsModalOpen(false);
  };

  const handleEditName = () => {
    setEditNickname(userInfo?.user.nickname || "");
    setEditName(true);
  };

  const confirmName = () => {
    console.log(editNickname);
    
    if (editNickname === "") {
      message.warning("昵称不能为空");
      return;
    }
    if (userInfo && userInfo.user) {
      handleUpdateNickname();
      setUserInfo({
        ...userInfo,
        user: {
          ...userInfo.user,
          nickname: editNickname,
        },
      });
    }
    setEditName(false);
  };

  const cancelEdit = () => {
    setEditNickname(userInfo?.user.nickname || "");
    setEditName(false);
  };

  return (
    <div className="mine-container">
      <Title
        setShowOptions={setShowOptions}
        showOptions={showOptions}
        setShowCreate={setShowCreate}
        type="mine"
      />
      <div className="mine">
        <div className="item">
          <p>昵称</p>
          <Input
            size="large"
            value={editName ? editNickname : userInfo?.user.nickname}
            disabled={!editName}
            style={{ width: "400px", paddingRight: "100px" }}
            onChange={(e) => editName && setEditNickname(e.target.value)}
          />
          {editName ? (
            <div className="btnss">
              <div className="btn" onClick={confirmName}>
                确认
              </div>
              <div className="btn" onClick={cancelEdit}>
                取消
              </div>
            </div>
          ) : (
            <div className="btnss">
              <div className="btn" onClick={handleEditName}>
                修改
              </div>
            </div>
          )}
        </div>
        <div className="item">
          <p>手机号</p>
          <Input
            size="large"
            placeholder="未绑定"
            value={userInfo?.user.phone}
            style={{ width: "400px" }}
            disabled
          />
          {userInfo?.user.phone ? (
            <div className="btnss">
              <div className="btn" onClick={() => handlePhone("修改手机号")}>
                修改
              </div>
              <div className="btn" onClick={() => message.warning("无法解除绑定，需要至少绑定手机号或电子邮箱中的一种")}>
                解除绑定
              </div>
            </div>
          ) : (
            <div className="btnss">
              <div className="btn" onClick={() => handlePhone("绑定手机号")}>
                绑定
              </div>
            </div>
          )}
        </div>
        {/* <div className="item">
          <p>电子邮箱</p>
          <Input
            size="large"
            placeholder="未绑定"
            value={userInfo.user.email}
            style={{ width: "400px" }}
            disabled
          />
          {userInfo.user.email ? (
            <div className="btnss">
              <div className="btn">修改</div>
              <div className="btn">解除绑定</div>
            </div>
          ) : (
            <div className="btnss" onClick={handleEmail}>
              <div className="btn">绑定</div>
            </div>
          )}
        </div> */}
      </div>
      <Modal
        title={title}
        closable={{ "aria-label": "Custom Close Button" }}
        open={isModalOpen}
        onOk={handleOk}
        onCancel={handleCancel}
        destroyOnHidden
        okText="确定"
        cancelText="取消"
      >
        <Form
          name="basic"
          labelCol={{ span: 8 }}
          wrapperCol={{ span: 12 }}
          style={{ maxWidth: 600 }}
          initialValues={{ remember: true }}
          autoComplete="off"
          ref={formRef}
          
        >
          <Form.Item
            label="新手机号"
            name="phone"
            rules={[
              { required: true, message: "请输入手机号!" },
              { pattern: /^1[3-9]\d{9}$/, message: "请输入有效的手机号!" }
            ]}
          >
            <Input placeholder="请输入手机号"/>
          </Form.Item>
          <Form.Item
            label="验证码"
            name="code"
            rules={[
              { required: true, message: "请输入验证码!" },
              { pattern: /^\d{6}$/, message: "请输入6位验证码!" }
            ]}
          >
              <Input
              placeholder="请输入6位验证码"
              addonAfter={
                <div
                  className="getCode"
                  style={{
                    color: countdown > 0 ? "#ccc" : "#1677ff",
                    cursor: countdown > 0 ? "not-allowed" : "pointer"
                  }}
                  onClick={() => {
                    if (countdown > 0) return;
                    if(!formRef.current.getFieldValue("phone") ) {
                      message.warning("请输入有效的手机号");
                      return;
                    }
                    getCodeRequest({phone:formRef.current.getFieldValue("phone"),codeType:"ModifyContact"});
                  }}
                >
                  {countdown > 0 ? `${countdown}秒后重试` : "获取验证码"}
                </div>
              }
            />
          </Form.Item>
        </Form>
      </Modal>
    </div>
  );
}
